import { Grid } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import LoopIcon from '@mui/icons-material/Loop';
import { useTranslate } from 'react-admin';

export const BulkActionsSection = (props: { onDelete: () => void; onRenew: () => void }) => {

  const translate = useTranslate();

  return (
    <Grid container display="flex" flexDirection="row" justifyContent="space-between" gap={1} alignItems="stretch">
      <Grid sx={{ flex: 1 }}>
        <button
          type="button"
          className="bulk-action-button"
          onClick={props.onRenew}
        >
          <LoopIcon />
          <span>{translate('resources.security-inventory-items.text.manage_inspection')}</span>
        </button>
      </Grid>
      <Grid sx={{ flex: 1 }}>
        <button
          type="button"
          className="bulk-action-button"
          onClick={props.onDelete}
        >
          <DeleteIcon />
          <span>{translate('ra.action.delete')}</span>
        </button>
      </Grid>
    </Grid>
  );

};
